<template lang="pug">
  .frame(:class="mod ? 'frame_' + mod : ''")
    .frame__border(v-for="item in borders", :class="'frame__border_' + item")
    .frame__title-cont(v-if="step")
      .frame__title Need for&nbsp;security
      .frame__subtitle(v-html="'Step&nbsp;' + step")
    slot
</template>

<script>
export default {
  name: 'Frame',
  props: ['step', 'mod'],
  data() {
    return {
      borders: ['top', 'bottom', 'left', 'right'],
    };
  },
};
</script>

<style lang="scss">
  .frame {
    position: relative;
    @include vertical-align;
    flex-direction: column;
    width: $frame-width;
    height: $frame-height;
    padding: 85px 120px 0;
    background: url(~@/assets/frame__bg.png) repeat-x;
    background-color: $clr-white;
    text-align: center;
    @media (max-width: $max-width-xs) {
      width: auto;
      height: 100vh;
      min-height: $frame-height-xs;
      max-height: $frame-height;
      flex: 0 0 100%;
      background: url(~@/assets/frame__bg-xs.png) repeat-x;
      background-size: contain;
      padding: 64px $gutter-width 0;
    }
    &_small-pad,
    &_big {
      padding-top: 55px;
      @media (max-width: $max-width-xs) {
        padding-top: 40px;
      }
    }
    &_big {
      @media (max-width: $max-width-xs) {
        min-height: 100vh;
        height: auto;
        max-height: none;
        padding-bottom: $frame-bottom-xs;
      }
    }
    &_center {
      padding-top: 0;
      justify-content: center;
    }
    &__title {
      @include typo-h1;
      color: $clr-main;
      margin: 0px 0 7px;
      &-cont {
        text-align: center;
      }
    }
    &__subtitle {
      @include typo-h3;
      color: $clr-main;
    }
    &__content {
      z-index: z('default') + 1;
      position: relative;
    }
    &__border {
      @include frame-borders;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UI/Frame.vue